// src/com/sms_message/SmsMessageLog.js
// import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { AppNumber } from '../../model/AppConst';
import SmsMessageList from './SmsMessageList';

const dcPad = AppNumber.dataContainerPadding;
const SmsMessageContainer = styled(Box)({ position:"absolute", top:dcPad, bottom:dcPad, left:dcPad, right:dcPad, display:"flex" });

/**
 * SMS 메시지 컴포넌트 (전송이력 보기 밖에 없음.)
 * @returns 
 */
export default function SmsMessageLog() {
    return (
        <SmsMessageContainer>
            <SmsMessageList
            />
        </SmsMessageContainer>
    );
}